import { render, staticRenderFns } from "./ListUtenti.vue?vue&type=template&id=4551cba8&"
import script from "./ListUtenti.vue?vue&type=script&lang=js&"
export * from "./ListUtenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports